// Modified by Sullivan Digital, 2026-10-26: the upsell page is not found (SALDP white-labelling). Licensed under the GNU AGPL v3.
import { DottedBackground } from "metabase/common/components/upsells/components/DottedBackground";
import { LineDecorator } from "metabase/common/components/upsells/components/LineDecorator";
import { useUpgradeAction } from "metabase/common/components/upsells/components/UpgradeModal";
import { UpsellCardContent } from "metabase/common/components/upsells/components/UpsellCardContent";
import { removedUpsellPage } from "metabase/common/components/upsells/components/removed-upsell";
import { MONITOR_UPGRADE_URL } from "metabase/common/components/upsells/constants";
import { Stack } from "metabase/ui";

import { MonitorHeaderTitle } from "../components/MonitorHeaderTitle";

import S from "./BaseUpsellPage.module.css";

export type BaseUpsellPageProps = {
  campaign: string;
  location: string;
  header: string;
  title: string;
  description: string;
  bulletPoints?: string[];
  image?: string;
  variant?: "image-full-height" | "image-card";
};

function BaseUpsellPageView({
  campaign,
  location,
  header,
  title,
  description,
  bulletPoints,
  image,
  variant,
}: BaseUpsellPageProps) {
  const { onClick: upgradeOnClick, url: upgradeUrl } = useUpgradeAction({
    url: MONITOR_UPGRADE_URL,
    campaign,
    location,
  });

  return (
    <DottedBackground px="3.5rem" pb="2rem">
      <MonitorHeaderTitle>{header}</MonitorHeaderTitle>
      <Stack align="center" p={40} className={S.UpsellPageContent}>
        <LineDecorator>
          <UpsellCardContent
            campaign={campaign}
            location={location}
            title={title}
            description={description}
            bulletPoints={bulletPoints}
            image={image}
            upgradeOnClick={upgradeOnClick}
            upgradeUrl={upgradeUrl}
            variant={variant}
          />
        </LineDecorator>
      </Stack>
    </DottedBackground>
  );
}

export const BaseUpsellPage = removedUpsellPage(BaseUpsellPageView);
